import { register, findAll, find } from '../../../../Javascript/Sysmex/Utils'

const CheckboxGroup = el => {
  const componentPrefix = el.dataset.componentprefix
  const hasClearAll = el.dataset.hasclearall
  const checkBoxComponents = findAll(`.${componentPrefix}field`, el)

  if (hasClearAll) {
    const clearAllBtn = find(`.${componentPrefix}clearAll`, el)
    clearAllBtn.addEventListener('click', () => {
      checkBoxComponents.forEach((checkBoxComponent) => {
        const nativeInputTypeCheckbox = find('input', checkBoxComponent)
        if (nativeInputTypeCheckbox.checked) {
          nativeInputTypeCheckbox.checked = false
        }
      })
    })
  }
}

register('CheckboxGroup', CheckboxGroup)
